(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        document.addEventListener('DOMContentLoaded', function () {
            eventDispatcher.on('click', '.show-auth-modal', function (event, targetElement) {
                var afterAuthUrl = targetElement && targetElement.dataset ? targetElement.dataset.afterAuthUrl : null;

                if (afterAuthUrl && window.authWidget && window.authWidget.links) {
                    window.authWidget.links.afterLoginRedirectLink = afterAuthUrl;
                }

                var wishlistTrigger = targetElement && targetElement.classList.contains('js-wishlist-onboarding-target') ? targetElement : null;

                if (wishlistTrigger && wishlistTrigger.dataset && wishlistTrigger.dataset.hotelId) {
                    sessionStorage.removeItem('wishlistAuthSuccessHotelId');
                    sessionStorage.setItem('wishlistAuthHotelId', wishlistTrigger.dataset.hotelId);
                    window.brxTracking.sendAnalyticsEvent('click_add_wishlist_hotel', {
                        HotelId: wishlistTrigger.dataset.hotelId,
                        Page: wishlistTrigger.dataset.page || 'new_hotel_view_page'
                    });
                }

                window.modal.open({
                    header: {
                        title: window.authWidget.labels.title
                    },
                    content: {
                        htmlDetachSelectorId: 'authModal'
                    },
                    parentCssClass: 'bottom-scheat-auth',
                    footer: false,
                    type: 'bottom',
                    onBeforeClose: function onBeforeClose() {
                        sessionStorage.removeItem('wishlistAuthHotelId');
                    },
                    onAfterShow: function onAfterShow() {
                        window.authWidget.sendOpenEvent();
                    }
                });
            });
        });
    }, {}] }, {}, [1]);